export default function (pluginHandler) {
    return {
        name: 'clone',
        treeRowMixins: {
            methods: {
                cloneDo(){
                    this.treeObject.$emit('clone', this.rowItem, this, this.cloneNumber)
                    this.cloneNumber++
                }
            },
            data(){
                return {
                    cloneNumber: 0
                }
            }
        },
        slotsContent: {
            rowActions: `<span class="fa fa-clone" @click="cloneDo"></span>`
        }
    }
}
